'use strict';

var addDomEvent = require('../../events/add-dom-event.cjs');
var createProjectionNode = require('./create-projection-node.cjs');

const DocumentProjectionNode = createProjectionNode.createProjectionNode({
    attachResizeListener: (ref, notify) => addDomEvent.addDomEvent(ref, "resize", notify),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => true,
});

exports.DocumentProjectionNode = DocumentProjectionNode;
//# sourceMappingURL=DocumentProjectionNode.cjs.map
